import {
  ArraySignatures,
  FixMe,
  Project,
} from '@greenkub-fronts/shared/interface';
import {
  GKToggleableInput,
  GKToggleableTextArea,
} from '@greenkub-fronts/shared/ui';
import { DATE_FORMAT, DateFromString } from '@greenkub-fronts/shared/utils';
import cx from 'classnames';

import styles from '../mandat-gestion/mandat-gestion.module.scss';
import templateStyles from '../base-template.module.scss';
import mainStyles from '../../document-signature-container/document-signature-container.module.scss';
import bdcStyles from '../bdc/bdc.module.scss';

export interface DechargeNonConformiteProps {
  project: Project;
  isSignature: boolean;
  signature: string;
  signatures: ArraySignatures;
  handleOpenModalSignHandler: (index: number) => void;
  sign1Ref: FixMe;
  lastName: string;
  firstName: string;
  setLastName: (value: string) => void;
  setFirstName: (value: string) => void;
  body: string;
  body2: string;
  setBody: (value: string) => void;
  setBody2: (value: string) => void;
  date: string;
}

const DechargeNonConformite = (props: DechargeNonConformiteProps) => {
  const {
    project,
    isSignature,
    signature,
    signatures,
    handleOpenModalSignHandler,
    sign1Ref,
    lastName,
    firstName,
    setLastName,
    setFirstName,
    body,
    body2,
    setBody,
    setBody2,
    date,
  } = props;

  return (
    <div
      className={cx(
        mainStyles['LandingPage'],
        styles['MandatGestion'],
        mainStyles['pages-container']
      )}
    >
      <div
        className={cx(
          mainStyles['LandingPage-page'],
          templateStyles['Template'],
          styles['page']
        )}
      >
        <div
          className={cx(styles['Template-head'], styles['MandatGestion-head'])}
        >
          <h1>Décharge de non conformité</h1>
        </div>

        <div
          className={cx(
            templateStyles['Template-content'],
            styles['MandatGestion-content']
          )}
        >
          <div className={styles['NameLine']}>
            <p>
              Je soussigné(e)&nbsp;
              {isSignature ? (
                <span>{lastName}&nbsp;</span>
              ) : (
                <GKToggleableInput
                  value={lastName}
                  onChange={(value: string) => setLastName(value)}
                  className={'mr5'}
                />
              )}
              {isSignature ? (
                <span>{firstName}</span>
              ) : (
                <GKToggleableInput
                  value={firstName}
                  onChange={(value: string) => setFirstName(value)}
                />
              )}
            </p>
          </div>
          {isSignature ? (
            <p className={styles['BodyLine']}>{body}</p>
          ) : (
            <GKToggleableTextArea
              value={body}
              onChange={(value: string) => setBody(value)}
              className={styles['BodyInput']}
            />
          )}
          {isSignature ? (
            <p className={styles['BodyLine']}>{body2}</p>
          ) : (
            <GKToggleableTextArea
              value={body2}
              onChange={(value: string) => setBody2(value)}
              className={styles['BodyInput']}
            />
          )}
        </div>

        <div
          className={cx(
            templateStyles['Template-middle'],
            styles['MandatGestion-middle']
          )}
        >
          <div
            className={cx(
              templateStyles['Template-signature'],
              styles['MandatGestion-signature']
            )}
          >
            <span>
              Fait à {project?.address?.city} le&nbsp;
              {isSignature ? (
                <>{DateFromString(date, DATE_FORMAT.SLACH_DATE)}</>
              ) : (
                '<date de signature>'
              )}
            </span>

            <p>Pour faire valoir ce que de droit</p>
            <span>Signature</span>

            {isSignature &&
              (signatures[0] === true ? (
                <p
                  className={cx(
                    templateStyles['Template-signed'],
                    styles['MandatGestion-signed']
                  )}
                >
                  {signature}
                </p>
              ) : (
                <div
                  ref={sign1Ref}
                  className={cx(
                    templateStyles['Template-signatureBox'],
                    styles['MandatGestion-signed'],
                    signatures[0] === 'pulse' && bdcStyles['pulse']
                  )}
                  onClick={() => {
                    handleOpenModalSignHandler(0);
                  }}
                >
                  <span>Cliquez ici pour apposer votre signature</span>
                </div>
              ))}
          </div>
        </div>

        <div className={templateStyles['Template-foot']}>
          <p>
            SAS Greenkub - RCS N° 798802377 au capital de 1 249 731,29 Euros - TVA
            N° FR27798802377
          </p>
          <p>
            300 Avenue de la Royale 34160 Castries - France - Tel&nbsp;: 09 74
            59 41 72
          </p>
        </div>
      </div>
    </div>
  );
};

export default DechargeNonConformite;
